import React, { FC, useEffect, useState } from "react";
import { Form, Modal, Button, Alert, Row, Col, Tabs, Tab } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { UserModel } from "../../../../models/UserModel";
import { UserType } from "../../../../types/UserType";
import ClipLoader from "react-spinners/ClipLoader";
import { useAuth } from "../../../../hooks/useAuth";
import { AuthContext } from "../../../../providers/AuthContextProvider";
import { RodType } from "../../../../types/RodType";
import { RodModel } from "../../../../models/RodModel";
import InputMask from "react-input-mask";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_CANCEL, LANG_COMMON_CODE, LANG_COMMON_NO, LANG_COMMON_SAVE, LANG_COMMON_YES, LANG_ERROR, LANG_PERSON_NEW_ROD, LANG_PERSON_ROD_FREEZING_DATE, LANG_PERSON_ROD_FRESH, LANG_PERSON_ROD_FROZEN, LANG_PERSON_ROD_OVULES_QTY, LANG_PERSON_ROD_TYPE, LANG_PERSON_ROD_USED, LANG_WARNING_FILL_ALL } from "../../../../lang";
import PersonBasicForm from "../form/PersonBasicForm";
import { PersonPhenotypeType, PersonType } from "../../../../types/PersonType";
import { PersonModel } from "../../../../models/PersonModel";
import PersonPhenotypeForm from "../form/PersonPhenotypeForm";

interface Props {
    show: boolean
    onHide: () => void
    onSave: () => void
    person: PersonType
}
const PersonPhenotypesModal: FC<Props> = ({ show, onHide, onSave, person }) => {
    const intl = useIntl();
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState<boolean | string>(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [phenotypes, setPhenotypes] = useState<PersonPhenotypeType | undefined>(undefined);

    const loadFromMatching = (personId: number) => {
        setLoading(true);
        PersonModel().getPhenotypesFromMatching(personId).then((resp) => {
            if (typeof resp !== "boolean") {
                delete resp.schooling;
                resp.height = resp.height_number;
                setPhenotypes(resp);
            } else {
                setErrorMsg("Houve um erro desconhecido! Por favor, tente novamente!");
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        if (person.id && person.yvia_matching_id) {
            loadFromMatching(person.id);
        }
    }, [person.id]);

    return (
        <Modal
            size="xl"
            show={show}
            onHide={() => {
                onHide();
            }}
            className="modal-default"
        >
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title>
                    Editar Fenótipos
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {typeof errorMsg !== "boolean" && (<Alert variant={'danger'}>{errorMsg}</Alert>)}
                <div className="mt-3">
                    {loading && (<div className="text-center my-5"><ClipLoader color={'#000000'} loading={loading} size={'30px'} /></div>)}
                    {!loading && (
                        <PersonPhenotypeForm
                            person={person}
                            personPhenotype={phenotypes}
                            hasSubmitted={hasSubmitted}
                            onSubmit={(personPhenotypes) => {
                                setLoading(true);
                                setErrorMsg(false);
                                setHasSubmitted(false);

                                if(person.yvia_matching_id === null || person.yvia_matching_id === undefined){
                                    PersonModel().createOnMatching(person.id, personPhenotypes).then((resp) => {
                                    if (typeof resp === "boolean") {
                                        onSave();
                                    } else {
                                        setErrorMsg("Houve um erro desconhecido! Por favor, tente novamente!");
                                    }
                                    setLoading(false);
                                });
                                } else {
                                    PersonModel().updateOnMatching(person.id, personPhenotypes).then((resp) => {
                                        if (typeof resp === "boolean") {
                                            onSave();
                                        } else {
                                            setErrorMsg("Houve um erro desconhecido! Por favor, tente novamente!");
                                        }
                                        setLoading(false);
                                    });
                                }
                            }}
                        />
                    )}
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                    {intl.formatMessage(LANG_COMMON_CANCEL)}
                </Button>
                <Button
                    onClick={() => {
                        setHasSubmitted(true);
                        setTimeout(() => {
                            setHasSubmitted(false);
                        }, 100)
                    }}
                    variant="primary" type="button" disabled={loading} className="btn-custom bg-custom-gradient">
                    {loading ? <><ClipLoader color={'#ffffff'} loading={loading} size={'12px'} /></> : intl.formatMessage(LANG_COMMON_SAVE)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PersonPhenotypesModal;